import React from "react";
import './../styles/Loader.css';

const Loader = ({
  forButton = false, // Added forButton prop
  message = "Preparing fertilizer recommendation",
  submessage = [
    "Analyzing soil nutrients…",
    "Checking crop requirements…",
    "Optimizing dosage…",
    "Finalizing recommendation…"
  ],
  submessageInterval = 700
}) => {
  const submessages = Array.isArray(submessage)
    ? submessage
    : [submessage];

  const [index, setIndex] = React.useState(0);

  React.useEffect(() => {
    if (submessages.length <= 1) return;

    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % submessages.length);
    }, submessageInterval);

    return () => clearInterval(timer);
  }, [submessages.length, submessageInterval]);

  if (forButton) { // Conditional rendering for buttons
    return <div className="loader-button-spinner"></div>;
  }

  return (
    <div className="plant-loader-container" role="status" aria-live="polite">
      <div className="plant-loader">
        <div className="plant-ground" />

        <div className="plant-stem">
          <div className="plant-leaf plant-leaf-1" />
          <div className="plant-leaf plant-leaf-2" />
          <div className="plant-leaf plant-leaf-3" />

          <div className="plant-flower">
            <div className="flower-petal" />
            <div className="flower-petal" />
            <div className="flower-petal" />
            <div className="flower-petal" />
            <div className="flower-petal" />
            <div className="flower-center" />
          </div>
        </div>

        <div className="pollen-particle pollen-1" />
        <div className="pollen-particle pollen-2" />
        <div className="pollen-particle pollen-3" />
        <div className="pollen-particle pollen-4" />
      </div>

      {message && <div className="loader-message">{message}</div>}

      {submessages[index] && (
        <div key={index} className="loader-submessage">
          {submessages[index]}
        </div>
      )}

      <span className="sr-only">Loading, please wait</span>
    </div>
  );
};

export default Loader;
